import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

import useAlert from 'hooks/useAlert';
import { useDetectAdBlock } from 'hooks/useDetectAdBlock';

/**
 * @author @buunsal
 */

const AdBlockDetected = () => {
	const adBlockDetected = useDetectAdBlock();
	const { showWarning } = useAlert();
	const { pathname } = useLocation();

	useEffect(() => {
		const isRegisterOrLogin =
			pathname.split('/')[1] === 'register' ||
			pathname.split('/')[1] === 'login' ||
			pathname.split('/')[1] === 'forgot-password' ||
			pathname.split('/')[1] === 'register-with-provider';
		if (adBlockDetected && isRegisterOrLogin) {
			showWarning({
				header: 'adBlockDetectedHeader',
				message: 'adBlockDetectedMessage'
			});
		}
	}, [adBlockDetected]);
	return <></>;
};

export default AdBlockDetected;
